import { useState, useRef, useEffect } from 'react'
import LoadingBar from 'react-top-loading-bar';

import MainHeader from './MainHeader'
import { useTheme } from '../providers/ThemeProvider'
import { SubmitModal } from '../product-request'
import NotificationBar from '../components/NotificationBar'
// import { useUser } from '../providers/UserProvider';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const StickyHeader = () => {
  const loadingBarRef = useRef(null);
  // const [user, userDispatch] = useUser();
  const [theme, themeDispatch] = useTheme();

  // const [showModal, setShowModal] = useState(user.productRequestShowModal);

  // useEffect(() => {
  //   console.log('user changed', user)
  //   setShowModal(user.productRequestShowModal);
  // }, [user]);

  return (
    <>
      <LoadingBar color='#0173FF' ref={loadingBarRef} />
      {/* <SubmitModal open={showModal} setOpen={setShowModal} loadingBarRef={loadingBarRef} /> */}
      <SubmitModal loadingBarRef={loadingBarRef} />
      <div 
        className={classNames((theme.headerDark ? 'bg-convoy-blue' : 'bg-convoy-homepage'), "sticky top-0 z-50")}
      >
        <NotificationBar />
        <div className="container">
          <MainHeader />
        </div>
      </div>
    </>
  )
}

export default StickyHeader;
